import { render, staticRenderFns } from "./CoVideoCourse.vue?vue&type=template&id=754b7890&scoped=true&"
import script from "./CoVideoCourse.vue?vue&type=script&lang=js&"
export * from "./CoVideoCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b7890",
  null
  
)

export default component.exports